var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "menu-container" } },
    [
      _vm._l(_vm.menus, function (menu) {
        return _vm.filterMenu(menu)
          ? [
              _vm.thumb === 1
                ? _c(
                    "div",
                    { key: menu.id, staticStyle: { "text-align": "center" } },
                    [
                      _c("i", {
                        class: menu.icon
                          ? menu.icon + " thumb"
                          : "iconmenu el-icon-menu-default thumb",
                      }),
                    ]
                  )
                : _vm._e(),
              _vm.thumb !== 1
                ? _c(
                    "div",
                    { key: menu.id, staticClass: "item" },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "m1",
                          attrs: { id: "menu_" + menu.id },
                          on: {
                            click: function ($event) {
                              return _vm.jump(menu)
                            },
                          },
                        },
                        [
                          _c("i", {
                            class: menu.icon || "iconmenu el-icon-menu-default",
                          }),
                          _vm._v(" " + _vm._s(menu.name) + " "),
                          _c("span"),
                        ]
                      ),
                      _c("nav-menu-item", {
                        attrs: { parent: menu, menus: _vm.menus },
                        on: { setMenu: _vm.jump },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ]
          : _vm._e()
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }